import React, { useEffect, useRef, useState } from 'react';

import LandingTopbar from './LandingTopbar';

import {  useTranslation } from 'react-i18next';
import { ExhibitionCarousel2, MuseumCarousel2 } from '../../components';
import AuthService from '../../security/AuthService';
import LandingFooter from './LandingFooter';
import { Toast } from 'reactstrap';
import ExhibitionService from '../../service/ExhibitionService';
import EventBus from "../../common/EventBus";
import Constants from '../../constants/Constants';
import CompanyService from '../../service/CompanyService';
import FavoriteService from '../../service/FavoriteService';
import ArtistCarousel from '../../components/ArtistCarousel';


export const Landing = (props) => {
    const { t } = useTranslation();

    const toast = useRef(null);
    console.log("Landing props", props );



    const [favoriteExhibits, setFavoriteExhibits] = useState([]);
    const [favoriteArtists, setFavoriteArtists] = useState([]);


    const [newExhibits, setNewExhibits] = useState([]);
    const [museumData, setMuseumData] = useState([]);


    useEffect(() => {
        loadNewExhibits();
        loadFavoriteExhibits();
        loadFavoriteArtists();
        loadMuseums();
    }, []);

    const prepareExhibits = (param) => {
        let _exhibits = [];
        param.map((item, index) => {
            _exhibits.push({
                label: item.exhibitionName,
                image: item.profileImage
            })
        });
        console.log("prepareExhibits", _exhibits)
        setNewExhibits(_exhibits);
    }
    const loadNewExhibits = async () => {
        setNewExhibits([]);
        ExhibitionService.inquireNewExhibits( ).then(
            (response) => {
                console.log("inquireNewExhibits", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireNewExhibits", response?.data?.data?.dataList)
                    setNewExhibits(response?.data?.data?.dataList);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibitByStatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current?.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }
    const loadFavoriteExhibits = async () => {
        setFavoriteExhibits([]);
        ExhibitionService.inquireFavoriteExhibits( ).then(
            (response) => {
                console.log("inquireFavoriteExhibits", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFavoriteExhibits", response?.data?.data?.dataList)
                    setFavoriteExhibits(response?.data?.data?.dataList);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireFavoriteExhibits logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current?.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }

    const loadFavoriteArtists = async () => {
        setFavoriteArtists([]);
        FavoriteService.inquireFavoriteArtists( ).then(
            (response) => {
                console.log("inquireFavoriteArtists", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFavoriteArtists", response?.data?.data?.dataList)
                    setFavoriteArtists(response?.data?.data?.dataList);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireFavoriteArtists logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current?.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }

    const loadMuseums = async () => {
        setMuseumData([]);
        CompanyService.inquireFeaturedMuseums( ).then(
            (response) => {
                console.log("inquireFeaturedMuseums", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireFeaturedMuseums", response?.data?.data?.dataList)
                    setMuseumData(response?.data?.data?.dataList);
                }
            },
            (error) => {

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireFeaturedMuseums logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current?.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }

    return (

        <div className='root-landing' style={{ paddingBottom: 70 }}>
          <Toast ref={toast} />

            <div className="grid grid-nogutter surface-landing-main text-800" >

                <LandingTopbar {...props} toast={toast} />

                


                <div className="surface-landing" >


                    <div className="col-12 p-0 md:text-left ">
                        <section>
                            <span className="block text-6xl font-bold mb-1">
                                {AuthService.getFullName() ? t('landing_header1_with_user', { username: AuthService.getFullName() }) : t('landing_header1')}
                            </span>
                            <br />
                            <br />
                            <br />
                            <br />
                            <div className="text-4xl  mb-3">
                                {t('landing_header2')}
                            </div>


                            <div style={{ paddingTop: 30 }}>
                                <a href="/search?companyCode=museum" className="flex p-1 landing-menu " ><i className="pi pi-chevron-right  "><span className=" text-3xl"> {t('menu_museums')}</span> </i></a>

                                <a href="/search?companyCode=art_gallery" className="flex p-1 landing-menu " ><i className="pi pi-chevron-right  "><span className=" text-3xl"> {t('menu_galeries')}</span> </i></a>
                                <a href={"/search?searchType="+Constants.searchType.ARTISTS} className="flex p-1 landing-menu " ><i className="pi pi-chevron-right  "><span className=" text-3xl"> {t('global_text_artists')}</span> </i></a>
                                <a href="#menu_discover" className="flex p-1 landing-menu " ><i className="pi pi-chevron-right  "><span className=" text-3xl"> {t('menu_discover')}</span> </i></a>
                            </div>
                        </section>



                    </div>

                </div>


            </div>
            <div className="text-3xl  mb-3 p-3" id="menu_discover" >
                {t('landing_header3')}
                <ExhibitionCarousel2 data={newExhibits}></ExhibitionCarousel2>




            </div>
            <div className="text-3xl  mb-3 p-3" id="menu_discover" >
                {t('landing_header5')}
                <ExhibitionCarousel2 data={favoriteExhibits}></ExhibitionCarousel2>


            </div>
            <div className="text-3xl  mb-3 p-3" id="menu_discover" >
                {t('landing_header6')}
                <ArtistCarousel data={favoriteArtists}></ArtistCarousel>


            </div>

            <div className="text-3xl  mb-3 p-3">
                {t('landing_header4')}
                <MuseumCarousel2 data={museumData}></MuseumCarousel2>


            </div>

            {/*<MuseumCarousel data={museumData}></MuseumCarousel> */}

            <LandingFooter {...props}></LandingFooter>
        </div>

    );
};

